import React, {useState} from 'react';
import { FixedSizeGrid as Grid } from 'react-window';
import AutoSizer from "react-virtualized-auto-sizer";


export default function GridList(props){
  const[columns, setColumns]=useState();
  const Cell = ({ columnIndex, rowIndex, style }) =>{

    let number=(rowIndex*columns)+columnIndex;
    if(props.list_items[number]==undefined){return null}
    return(
    <div style={style}>
      {props.component(props.list_items[number])}
    </div>
  );
  }

  return(
    <AutoSizer>
      {({ height, width }) => {
        let col=props.columns;
        if(props.responsive_columns!=undefined){for(let key in props.responsive_columns){if(width>key){col=props.responsive_columns[key];}}}
        if(columns!=col){setColumns(col);}
        return(
      <Grid
        className="Grid"
        columnCount={columns}
        columnWidth={width/columns}
        height={height}
        rowCount={Math.ceil(props.list_items.length/columns)}
        rowHeight={props.rowHeight}
        width={width}
      >
        {Cell}
      </Grid>
    )}}
    </AutoSizer>
);}
